import { LessonType, ModuleType } from '../../../types'

// Returns the total running time (in seconds) of all the
// videos within the lessons of the module

export const getModuleVideoLength = (module: ModuleType) => {
  if (!module.lessons) {
    return 0
  }

  const totalLessonVideoLength = module.lessons.reduce(
    (totalLessonVideoLength: number, lesson: LessonType) => {
      return totalLessonVideoLength + (lesson.video?.duration || 0)
    },
    0
  )

  return totalLessonVideoLength
}
